let mainProductSelectedVariant = document.querySelector('.top-custom-button');
if (mainProductSelectedVariant) {
  mainProductSelectedVariant.addEventListener('click', function () {
    // let mainSelectedVariantTitle = document.querySelector('.selected_variant_title')?.innerText.trim();
    let mainSelectedVariantTitle = document.querySelector('.swatch--color .pg__option__value.selected .swatch__item--single-color-text')?.innerText.trim();
    let customizedVariants = document.querySelectorAll('.variants .variant');
    customizedVariants.forEach(item => {
      let varTitle = item.getAttribute('data-variant-title')?.trim();
        let input = item.querySelector('input');
      if (mainSelectedVariantTitle == varTitle) {
        if (input) input.checked = true;
        item.classList.add('checked');
        updateSelectionState();
      } else {
        item.classList.remove('checked');
        if (input) input.checked = false;
         updateSelectionState();
      }
    });
  });
}

function showSelectedVariantTitle() {
  const allSelectedVariantTitles = document.querySelectorAll('.variant.checked');
  const selectedvariants = [];
  allSelectedVariantTitles.forEach(function(item) {
    const title = item.dataset.variantTitle?.trim();
    if (title) selectedvariants.push(title);
  });
  const selectedVariantTitleContainer = document.querySelector('p.product_selected_variant span');
  if (selectedVariantTitleContainer) {
    selectedVariantTitleContainer.textContent = selectedvariants.length ? selectedvariants.join(',  ') : '';
  }
}

// if ($(window).width() < 989) {
//   let mainProductSelectedVariant = document.querySelector('.top-custom-button');
//   if (mainProductSelectedVariant) {
//     mainProductSelectedVariant.addEventListener('click', function () {
//       const checkedVariant = document.querySelector('.variants .variant.checked');
//       if (checkedVariant) {
//         checkedVariant.scrollIntoView({
//           behavior: 'smooth',
//           inline: 'center',
//           block: 'nearest'
//         });
//       }
//     });
//   }
// }



  document.querySelector(".top-custom-button").addEventListener("click", function () {
    setTimeout (() => {
      const target = document.getElementById("step-1");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start", inline: 'center' });
      }
    }, 300);
  });

if ($(window).width() < 989) {
  let mainProductSelectedVariant = document.querySelector('.top-custom-button');

  if (mainProductSelectedVariant) {
    mainProductSelectedVariant.addEventListener('click', function () {
      const checkedVariant = document.querySelector('.variants .variant.checked');

      if (checkedVariant) {
        const headerOffset = 220; 
        const elementPosition = checkedVariant.getBoundingClientRect().top + window.scrollY - 100;
        const offsetPosition = elementPosition - headerOffset ;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  }

  // if (mainProductSelectedVariant) {
  //   mainProductSelectedVariant.addEventListener('click', function () {
  //     const checkedVariant = document.querySelector('.variants .variant.checked');
  //     if (!checkedVariant) return;

  //     const CheckedParent = checkedVariant.closest('.customizer_content_wrapper ');
  //     if (!CheckedParent) return;

  //     // Option A: simplest — aligns the section’s top with the viewport top
  //     // CheckedParent.scrollIntoView({
  //     //   behavior: 'smooth',
  //     //   block: 'start' // top of element to top of viewport
  //     // });

  //     // ---- OR ----
  //     // Option B: same effect using scrollTo (explicit math)
  //     const sectionTop = CheckedParent.getBoundingClientRect().top + window.scrollY;
  //     window.scrollTo({ top: sectionTop, behavior: 'smooth' });
  //   });
  // }


  // if (mainProductSelectedVariant) {
  //   mainProductSelectedVariant.addEventListener('click', () => {
  //     const checkedVariant = document.querySelector('.variants .variant.checked');
  //     if (!checkedVariant) return;

  //     const CheckedParent = checkedVariant.closest('section#step-1');
  //     if (!CheckedParent) return;

  //     requestAnimationFrame(() => {
  //       const header = document.querySelector('.sticky-header'); // adjust selector
  //       const headerOffset = header ? header.offsetHeight : 0;
  //       const top = CheckedParent.getBoundingClientRect().top + window.scrollY - headerOffset - 15;

  //       window.scrollTo({ top, behavior: 'smooth' });
  //     });
  //   });
  // }

  let extraOffset = 100; // first click offset

  if (mainProductSelectedVariant) {
    mainProductSelectedVariant.addEventListener('click', () => {
      const checkedVariant = document.querySelector('.variants .variant.checked');
      if (!checkedVariant) return;

      const CheckedParent = checkedVariant.closest('section#step-1');
      if (!CheckedParent) return;

      requestAnimationFrame(() => {
        const header = document.querySelector('.sticky-header'); // adjust selector
        const headerOffset = header ? header.offsetHeight : 0;

        const top = CheckedParent.getBoundingClientRect().top + window.scrollY - headerOffset - extraOffset;

        window.scrollTo({ top, behavior: 'smooth' });

        // after the first run, shrink the extraOffset
        if (extraOffset === 100) {
          extraOffset = 15;
        }
      });
    });
  }



  // let extraOffset = 100; // first click offset

  // if (mainProductSelectedVariant) {
  //   mainProductSelectedVariant.addEventListener('click', () => {
  //     const checkedVariant = document.querySelector('.variants .variant.checked');
  //     if (!checkedVariant) return;

  //     const CheckedParent = checkedVariant.closest('section#step-1');
  //     if (!CheckedParent) return;

  //     requestAnimationFrame(() => {
  //       const header = document.querySelector('.sticky-header'); // adjust selector
  //       const headerOffset = header ? header.offsetHeight : 0;

  //       const top = CheckedParent.getBoundingClientRect().top + window.scrollY - headerOffset - extraOffset;

  //       // 1) First pass: scroll near target with offsets
  //       window.scrollTo({ top, behavior: 'smooth' });

  //       // 2) Second pass: align the section top to viewport top
  //       // Prefer Scrollend when available; otherwise fallback to a short timeout.
  //       const alignToTop = () => {
  //         // double-rAF helps after layout settles on iOS
  //         requestAnimationFrame(() => {
  //           requestAnimationFrame(() => {
  //             CheckedParent.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //           });
  //         });
  //       };

  //       let usedScrollEnd = false;
  //       const onScrollEnd = () => {
  //         if (usedScrollEnd) return;
  //         usedScrollEnd = true;
  //         window.removeEventListener('scrollend', onScrollEnd);
  //         alignToTop();
  //       };

  //       if ('onscrollend' in window) {
  //         // Newer browsers (including recent iOS Safari) support this
  //         window.addEventListener('scrollend', onScrollEnd, { once: true });
  //       } else {
  //         // Fallback for older engines: slight delay, then align
  //         setTimeout(alignToTop, 250);
  //       }

  //       // After the first run, shrink the extra offset
  //       if (extraOffset === 100) {
  //         extraOffset = 15;
  //       }
  //     });
  //   });
  // }







}


function updateSidebarStepNumbers() {
  const stepItems = document.querySelectorAll('.customizer_step_bar .step-item');
  let stepCount = 1;
  if(stepItems){
      stepItems.forEach(item => {
      if (item.offsetParent !== null) {
        const circle = item.querySelector('.step-circle');
        if (circle) circle.textContent = stepCount++;
      }
    });
  }
}

//  When Patch is needed (Thread hidden)
function showPatchStepHideThread() {
  document.querySelector('[data-patch-step="true"]')?.classList.remove('hidden');
  document.querySelector('[data-thread-step="true"]')?.classList.add('hidden');
  updateSidebarStepNumbers();
}

//  When Thread is needed (Patch hidden)
function showThreadStepHidePatch() {
  document.querySelector('[data-thread-step="true"]')?.classList.remove('hidden');
  document.querySelector('[data-patch-step="true"]')?.classList.add('hidden');
  updateSidebarStepNumbers();
}

const checkboxes = document.querySelectorAll('.variant input[type="checkbox"]');
const maxSelection = 8;
const selectedContainer = document.querySelector('.selected-variants-container');
function updateSelectionState() {
  const checkedBoxes = document.querySelectorAll('.variant input[type="checkbox"]:checked');
  const selectedCount = checkedBoxes.length;
  checkboxes.forEach(input => {
    const label = input.closest('.variant');
    if (input.checked) {
      label?.classList.add('checked');
    } else {
      label?.classList.remove('checked');
    }
    // Disable others if 8 selected
    input.disabled = !input.checked && selectedCount >= maxSelection;
    label?.classList.toggle('disabled', input.disabled);
  });
  updateSelectedVariantsUI();
}

// Event listener for checkboxes
checkboxes.forEach(input => {
  input.addEventListener('change', updateSelectionState);
  input.addEventListener('change', updateIncentiveBars);
  input.addEventListener('change', showSelectedVariantTitle);
});

window.addEventListener('pageshow', function (event) {
  const checkboxes = document.querySelectorAll('.variant input[type="checkbox"]');
  // checkboxes.forEach(input => {
  //   input.checked = false;
  //   input.disabled = false;
  //   const label = input.closest('.variant');
  //   label?.classList.remove('checked', 'disabled');
  // });
  // const firstCheckbox = checkboxes[0];
  // if (firstCheckbox) {
  //   firstCheckbox.checked = true;
  //   const firstLabel = firstCheckbox.closest('.variant');
  //   // firstLabel?.classList.add('checked');
  // }
  
  updateSelectionState();
  
  const threadNotes = document.querySelector('#thread_notes');
  if (threadNotes) {
    threadNotes.value = '';
  }
  
  const leatherNotes = document.querySelector('#leather_patch_notes');
  if (leatherNotes) {
    leatherNotes.value = '';
  }

  const patchShape = document.querySelector('#patch_shape');
  if (patchShape) {
    patchShape.selectedIndex = 1;
  }

  const patchColor = document.querySelector('#patch_color');
  if (patchColor) {
    patchColor.selectedIndex = 1;
  }

  const orderNotes = document.querySelector('#order_notes');
  if (orderNotes) {
    orderNotes.value = '';
  }

  const termsCheckBox = document.querySelector('#terms_condition');
  if (termsCheckBox) {
    termsCheckBox.checked = false;
  }
  
});

let sideBarSteps = document.querySelectorAll('.step-item');
if(sideBarSteps){
  sideBarSteps.forEach(step => {
    step.addEventListener('click', function () {
      sideBarSteps.forEach(s => s.classList.remove('active'));
      this.classList.add('active');
    });
  });
}

function updateSelectedVariantsUI() {
  const allChecked = document.querySelectorAll('.variant.checked');
  if(!selectedContainer) return;
  const existingBoxes = selectedContainer.querySelectorAll('.selected-variant-box');
  existingBoxes.forEach(box => {
    const variantId = box.dataset.variantId;
    const stillChecked = Array.from(allChecked).some(label => label.dataset.variantId === variantId);
    if (!stillChecked) box.remove();
  });
  allChecked.forEach(label => {
    const title = label.dataset.variantTitle || "";
    const imgSrc = label.dataset.variantImg || "";
    const variantId = label.dataset.variantId || "";
    const price = label.dataset.variantPrice;
    const productTitle = label.dataset.productTitle || "";
    const key = title ? title.replace(/\s+/g, '-').toLowerCase() : "";
    const exists = selectedContainer.querySelector(`.selected-variant-box[data-variant-id="${variantId}"]`);
    if (exists) return; // Skip if already added
    const variantBox = document.createElement('div');
    variantBox.className = "selected-variant-box";
    variantBox.dataset.key = key;
    variantBox.dataset.variantId = variantId;
    variantBox.dataset.variantTitle = title;
    variantBox.dataset.variantImage = imgSrc;
    variantBox.dataset.variantPrice = price;
    variantBox.dataset.productTitle = productTitle;
    variantBox.innerHTML = `
     <button class="remove-variant" aria-label="Remove">&times;</button>
      <img class="selected_variant_img" src="${imgSrc}" alt="${title}" style="width:100px; height:100px; object-fit: cover;">
      <div class="quantity-selector">
        <button class="decrease">&minus;</button>
        <input type="number" class="quantity variant-quantity" value="1" min="1">
        <button class="increase">&plus;</button>
      </div>
      <p class="selected_variant_title">${title}</p>
    `;
    selectedContainer.appendChild(variantBox);
       //  Add remove button event listener
    const removeBtn = variantBox.querySelector('.remove-variant');
    removeBtn.addEventListener('click', () => {
      // Uncheck the corresponding variant checkbox
      const checkbox = document.querySelector(`.variant input[type="checkbox"][data-variant-id="${variantId}"]`);
      if (checkbox) checkbox.checked = false;
      // Trigger update
      variantBox.remove();
      const variantElement = document.querySelector(`.variant[data-variant-id="${variantId}"]`);
      if (variantElement) {
        variantElement.classList.remove('checked');
        variantElement.querySelector('input[type="checkbox"]').disabled = false;
      }
      updateSelectionState(); // refresh UI and validation state
      getTotalSelectedQuantity();
      showSelectedVariantTitle();
      setTimeout(() => {
        syncUIQuantities();
        const { totalQty } = getTotalVariantQuantityAndPrice();
        calculateCustomizationBlocksPrice(totalQty);
        extraArtWorkSetUpProduct();
     }, 100);
    });
  });
}
updateSelectedVariantsUI();

// progressbar js
function getTotalSelectedQuantity() {
  let total = 0;
  // Sum all selected quantities
  document.querySelectorAll('.selected-variant-box .variant-quantity')?.forEach(input => {
    const qty = parseInt(input.value, 10);
    if (!isNaN(qty)) total += qty;
  });
  // Update quantity display elements
  document.querySelectorAll('.selected_item_qty').forEach(el => {
    el.innerText = total;
  });
  // Update artwork setup message elements
  document.querySelectorAll('.free_setup_text').forEach(el => {
    el.innerText = total > 12
      ? ' (Free Artwork Setup)'
      : '(Incl. $25 Artwork Setup)';
  });
  // updateAtworkSetup();
  return total;
}

function updateIncentiveBars() {
  const totalQty = getTotalSelectedQuantity();
  const bars = document.querySelectorAll('.incentive-box');
  bars.forEach((bar, index) => {
    const threshold = parseInt(bar.dataset.min, 10);
    const prevThreshold = index === 0
      ? 0
      : parseInt(bars[index - 1].dataset.min, 10);
    const range = threshold - prevThreshold;
    const progress = totalQty - prevThreshold;
    const percent = Math.min(100, Math.max(0, (progress / range) * 100));

    // Fill progress bar
    const fill = bar.querySelector('.fill');
    if (fill) fill.style.width = percent + '%';

    // Toggle lock/unlock
    const status = bar.querySelector('.status');
    if (!status) return;

    if (totalQty >= threshold) {
      status.innerHTML = '✅ Unlocked';
      status.classList.add('unlocked');
      bar.classList.add('unlock_box');
      bar.classList.remove('locked');
    } else {
      status.innerHTML = '🔒 Locked';
      status.classList.remove('unlocked');
      bar.classList.remove('unlock_box');
      bar.classList.add('locked');
    }
  });
  updateAtworkSetup();
}

document.removeEventListener('click', handleQuantityClick); 
document.addEventListener('click', handleQuantityClick);

function handleQuantityClick(e) {
  const btn = e.target;
  if (!btn.classList.contains('increase') && !btn.classList.contains('decrease')) return;
  const wrapper = btn.closest('.quantity-selector');
  if (!wrapper) return;
  const input = wrapper.querySelector('input.variant-quantity');
  let value = parseInt(input.value, 10) || 1;
  if (btn.classList.contains('increase')) {
    value += 1;
  } else if (btn.classList.contains('decrease')) {
    value = Math.max(1, value - 1);
  }
  input.value = value;
  // Update bars
  updateIncentiveBars();
}

//  Run update when input is changed manually
function handleQuantityInputChange(e) {
  const input = e.target;
  if (!input.classList.contains('variant-quantity')) return;
  let value = parseInt(input.value, 10);
  if (isNaN(value) || value < 1) {
    input.value = 1;
  }
  // Update bars
  updateIncentiveBars();
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', handleQuantityClick);
  document.addEventListener('change', handleQuantityInputChange);
  // const firstVariant = document.querySelector('.variant');
  // if (firstVariant) {
  //   const checkbox = firstVariant.querySelector('input[type="checkbox"]');
  //   if (checkbox) {
  //     checkbox.checked = true;
  //     checkbox.dispatchEvent(new Event('change'));
  //   }
  // }
    updateIncentiveBars();
});

document.querySelectorAll('#artwork_block .artwork_block_header input.option-radio').forEach(input => {
  const block = input.closest('#artwork_block');
  if (input.checked) {
    block.classList.add('checked');
  }
   input.addEventListener('change', function () {
    document.querySelectorAll('#artwork_block').forEach(b => {
      b.classList.remove('checked');
    });
    const currentBlock = this.closest('#artwork_block');
    currentBlock.classList.add('checked');
    markActiveOptionBasedOnCheckedBlocks();
     updateAtworkSetup();
  });
});

document.querySelectorAll('.artwork_setup_block_header input.option-radio').forEach(input => {
  const block = input.closest('.artwork_setup_block');
  if (input.checked) {
    block.classList.add('checked');
  }
  input.addEventListener('change', function () {
    document.querySelectorAll('.artwork_setup_block').forEach(b => {
      b.classList.remove('checked');
    });
    const currentBlock = this.closest('.artwork_setup_block');
    currentBlock.classList.add('checked');
    markActiveOptionBasedOnCheckedBlocks();
    updateAtworkSetup();
  });
});

function markActiveOptionBasedOnCheckedBlocks() {
  const checkedTitles = Array.from(document.querySelectorAll('.artwork_block.checked'))
    .map(block => block.getAttribute('data-title')?.trim())
    .filter(Boolean);
  if (checkedTitles.length === 0) return;
  const varSelect = document.querySelector('.artwork_variant_selector');
  if (!varSelect) return;
  const options = Array.from(varSelect.options);
  options.forEach(option => option.classList.remove('active'));
  const matchedOption = options.find(option => {
    const optionValue = option.value.toLowerCase();
    return checkedTitles.every(title => optionValue.includes(title.toLowerCase()));
  });

if (matchedOption) {
  matchedOption.classList.add('active');
  const selectedOptionValue = matchedOption.value.toLowerCase();
  if (selectedOptionValue.includes('leather patch')) {
    document.querySelector('.leather_patch_section').style.display = 'block';
    document.querySelector('section#step-3 .step_footer_btn a.button').setAttribute('href', '#step-5');
    document.querySelector('.thread_color_section').style.display = 'none';
    showPatchStepHideThread();
  } else if (selectedOptionValue.includes('embroidery')) {
    document.querySelector('.leather_patch_section').style.display = 'none';
    document.querySelector('.thread_color_section').style.display = 'block';
    document.querySelector('.thread_color_section .step_footer_btn a.button').setAttribute('href', '#step-6');
    document.querySelector('section#step-3 .step_footer_btn a.button').setAttribute('href', '#step-4');
    showThreadStepHidePatch();
   }
 } 
}
markActiveOptionBasedOnCheckedBlocks();

// Store user selections for embroidery and design types
const blockSelections = {};

// FRONT GROUP (Only one allowed)
// document.querySelectorAll('.front_options .design-option input[type="checkbox"]').forEach(input => {
//   input.addEventListener('change', function () {
//     document.querySelectorAll('.front_options .design-option input[type="checkbox"]').forEach(otherInput => {
//       if (otherInput !== this) {
//         otherInput.checked = false;
//         otherInput.closest('.design-option').classList.remove('checked');
//       }
//     });
//     const parent = this.closest('.design-option');
//     if (this.checked) {
//       parent.classList.add('checked');
//     } else {
//       parent.classList.remove('checked');
//     }
//     renderAllCustomBlocks();
//   });
// });

document.querySelectorAll('.design-options.front_options .design-option').forEach(option => {
  option.addEventListener('click', function () {
    document.querySelectorAll('.design-options.front_options .design-option').forEach(opt => {
      opt.classList.remove('checked');
    });
    this.classList.add('checked');
    renderAllCustomBlocks();
  });
});


const secondOption = document.querySelectorAll('.design-options.front_options .design-option')[1];
if (secondOption) {
  secondOption.classList.add('checked');
}


// BACK & SIDE GROUP (Multiple allowed)
const backAndSideCheckboxes = document.querySelectorAll('.design-options.back_and_side input[type="checkbox"]');
backAndSideCheckboxes.forEach(input => {
  input.addEventListener('change', () => {
    const label = input.closest('.design-option');
    if (input.checked) {
      label.classList.add('checked');
    } else {
      label.classList.remove('checked');
    }
    renderAllCustomBlocks();
  });
});

// CREATE INDIVIDUAL CUSTOMIZATION BLOCK
function renderCustomizationBlock(locationKey, title, basePrice, image, variantId) {
  const id = `custom-${locationKey}`;
  if (document.getElementById(id)) return;
  const isSide = ['left-side', 'right-side', 'back-center'].includes(locationKey);
  const embroideryOptions = isSide ? '' : `
    <div class="embroidery-type">
      <p><strong>Choose an Embroidery Type</strong></p>
      <label class="embroidery-option option_label" data-value="flat" data-location="${locationKey}">
        <input type="radio" name="${locationKey}-embroidery" value="flat"> Flat $5
      </label>
      <label class="embroidery-option option_label" data-value="3d" data-location="${locationKey}">
        <input type="radio" name="${locationKey}-embroidery" value="3d"> 3D $8
      </label>
    </div>
  `;
  const html = `
  <div class="custom-block" id="${id}" data-variantprice=${basePrice} data-location="${locationKey}" data-variant-id="${variantId}">
    <div class="custom_block_img">
      <img src="${image}" alt="${title}" />
    </div>
    <div class="custom_block_info">
      <div class="info_header">
        <h4 class="header_title">${title}</h4>
        <p><strong class="custom-price">+$${basePrice.toFixed(2)}</strong></p>
      </div>
      ${embroideryOptions}
      <p class="design_type-title"><strong>Design Type</strong></p>
      <div class="design-type">
        <label for="${locationKey}-design-image" class="design_option option_label">
          <input type="radio" id="${locationKey}-design-image" name="${locationKey}-design" value="image"> Image
        </label>
        <label for="${locationKey}-design-text" class="design_option option_label">
          <input type="radio" id="${locationKey}-design-text" name="${locationKey}-design" value="text"> Text
        </label>
      </div>
      <div class="design-inputs">
        <div class="image-upload">
          <span class="img_label">Image</span>
          <label class="upload-label">
            <span>Drag & Drop your files or <span class=browse_link>Browse</span></span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="check_icon" style="display: none;">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </label>
          <input class="files" type="file" name="properties[Image]" />
        </div>
        <div class="text-input" style="display: none;">
          <label class="text_label">Text</label>
          <input type="text" placeholder="Enter your text" name="${locationKey}-text" />
        </div>
      </div>
      <small class="customize_block_warning">"${title}" is required</small>
       <div class="accordion-wrapper">
          <div class="accordion-item">
              <div class="accordion-header">
                <h6>What image file should I upload?</h6>
                <span class="accordion-toggle icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#000000" viewBox="0 0 256 256"><path d="M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z"/></svg></span>
              </div>
              <div class="accordion-content"> <p>AI, PDF, EPS, and SVG files preferred but PNG or JPEG is perfectly fine too. Upload a photo of your sign, truck, or any artwork — our team will take care of it.By uploading, you confirm you have rights to use the artwork.<span class="read_more_terms">[Read our Terms of Service.]</span></p></div>
          </div>
       <div class="accordion-wrapper">
    </div>
  </div>
  `;
// <p>AI, PDF, EPS, and SVG files preferred but PNG or JPEG is perfectly fine too. Upload a photo of your sign, truck, or any artwork — our team will take care of it.By uploading, you confirm you have rights to use the artwork.<span class="read_more_terms">[Read our Terms of Service.]</span></p>
  const container = document.getElementById('customization-container');
  container.insertAdjacentHTML('beforeend', html);
  const block = document.getElementById(id);
  // Restore previously selected values
  const saved = blockSelections[locationKey];
if (saved) {
if (saved.embroideryType) {
  // Clear previous selection first
  block.querySelectorAll(`input[name="${locationKey}-embroidery"]`).forEach(input => {
    input.checked = false;
    input.closest('.option_label')?.classList.remove('active');
  });
  const embroideryInput = block.querySelector(`input[name="${locationKey}-embroidery"][value="${saved.embroideryType}"]`);
  if (embroideryInput) {
    embroideryInput.checked = true;
    embroideryInput.closest('.option_label')?.classList.add('active');
    embroideryInput.dispatchEvent(new Event('change'));
  }
}
if (saved.designType) {
  block.querySelectorAll(`input[name="${locationKey}-design"]`).forEach(input => {
    input.checked = false;
    input.closest('.option_label')?.classList.remove('active');
  });
  const designInput = block.querySelector(`input[name="${locationKey}-design"][value="${saved.designType}"]`);
  if (designInput) {
    designInput.checked = true;
    designInput.closest('.option_label')?.classList.add('active');
    designInput.dispatchEvent(new Event('change'));
  }
}
}

// FILE PREVIEW
const fileInput = block.querySelector('input[type="file"]');
const labelText = block.querySelector('.upload-label span');
const checkIcon = block.querySelector('.check_icon');
const uploadLabel = block.querySelector('.upload-label');

// Handle file input change
fileInput.addEventListener('change', () => {
  if (fileInput.files.length > 0) {
    labelText.innerHTML = 'File Uploaded';
    checkIcon.style.display = 'inline';
  } else {
    labelText.innerHTML = 'Drag &amp; Drop your files or <span class="browse_link">Browse</span>';
    checkIcon.style.display = 'none';
  }
});

// IMAGE / TEXT TOGGLE
const imageRadio = block.querySelector(`input[name="${locationKey}-design"][value="image"]`);
const textRadio = block.querySelector(`input[name="${locationKey}-design"][value="text"]`);
const imageUpload = block.querySelector('.image-upload');
const textInput = block.querySelector('.text-input');
imageRadio.addEventListener('change', () => {
  if (imageRadio.checked) {
    imageUpload.style.display = 'block';
    textInput.style.display = 'none';
    const textInputField = textInput.querySelector('input[type="text"]');
    if (textInputField) textInputField.value = '';
  }
});
textRadio.addEventListener('change', () => {
  if (textRadio.checked) {
    imageUpload.style.display = 'none';
    fileInput.value = '';
    if (labelText) {
      labelText.innerHTML = 'Drag &amp; Drop your files or <span class="browse_link">Browse</span>';
    }
    if (checkIcon) {
      checkIcon.style.display = 'none';
    }
    textInput.style.display = 'block';
  }
});

  // ACTIVE CLASS TOGGLE
block.querySelectorAll(".option_label input[type='radio']").forEach(input => {
  const label = input.closest('.option_label');
  if (input.checked) label.classList.add('active');
  input.addEventListener('change', function () {
    const group = this.name;
    document.querySelectorAll(`input[name="${group}"]`).forEach(r => {
      const lbl = r.closest('.option_label');
      if (lbl) lbl.classList.remove('active');
    });
    if (label) label.classList.add('active');
  });
});
  
// embroidery type change (flat or 3d)
document.querySelectorAll('.custom-block .embroidery-option input[type="radio"]').forEach(input => {
  input.addEventListener('change', function () {
    const selectedType = this.value.toLowerCase(); // flat or 3d
    const parentLabel = this.closest('.embroidery-option');
    const fullLocation = parentLabel?.dataset.location?.toLowerCase(); // e.g., "front left flat$5"
    //  Extract only base location like "front left"
    const location = fullLocation?.split(' ')[0] + ' ' + fullLocation?.split(' ')[1];
    const flatGroup = document.querySelector('.design-options.flat_groups');
    const threeDGroup = document.querySelector('.design-options.three_d_groups');
    // Remove all "checked" classes
    document.querySelectorAll('.front_options .design-option').forEach(opt => opt.classList.remove('checked'));
    if (selectedType === '3d') {
      //  Show 3D group
      flatGroup.style.display = 'none';
      threeDGroup.style.display = 'flex';
      // Uncheck all radios in flat group
      flatGroup.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);
      const match3D = Array.from(threeDGroup.querySelectorAll('.design-option')).find(opt => {
        const optionLocation = opt.dataset.location?.toLowerCase();
        return optionLocation?.includes(location) && optionLocation.includes('3d');
      });
      if (match3D) {
        match3D.classList.add('checked');
        const radio = match3D.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        var selectedVarId = match3D.dataset.variantId;
        let selectedVarPrice = parseFloat(match3D.dataset.variantPrice || 0);
        selectedVarPrice = selectedVarPrice.toFixed(2);
        input.closest('.custom-block').dataset.variantId = selectedVarId;
        input.closest('.custom-block').querySelector('.custom-price').innerText = `+$${selectedVarPrice}`;
      }
    } else if (selectedType === 'flat') {
      threeDGroup.style.display = 'none';
      flatGroup.style.display = 'flex';
      // Uncheck all radios in 3D group
      threeDGroup.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false);
      const matchFlat = Array.from(flatGroup.querySelectorAll('.design-option')).find(opt => {
        const optionLocation = opt.dataset.location?.toLowerCase();
        return optionLocation?.includes(location) && optionLocation.includes('flat');
      });
      if (matchFlat) {
        matchFlat.classList.add('checked');
        const radio = matchFlat.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        var selectedVarId = matchFlat.dataset.variantId;
        let selectedVarPrice = parseFloat(matchFlat.dataset.variantPrice || 0);
        selectedVarPrice = selectedVarPrice.toFixed(2);
        input.closest('.custom-block').dataset.variantId = selectedVarId;
        input.closest('.custom-block').querySelector('.custom-price').innerText = `+$${selectedVarPrice}`;
      }
    }
  });
});

if(locationKey.includes('3D')){
   document.querySelector(`.custom-block .embroidery-option[data-value="3d"]`)?.click();
   document.querySelector(`.custom-block .design_option`)?.click();
}else if(locationKey.includes('Flat')){
   document.querySelector(`.custom-block .design_option`)?.click();
   document.querySelector(`.custom-block .embroidery-option[data-value="flat"]`)?.click();
}else if(locationKey.includes('Left Side')){
   document.querySelector(`.custom-block label.design_option.option_label[for="Left Side-design-image"]`)?.click();
}else if(locationKey.includes('Right Side')){
   document.querySelector(`.custom-block label.design_option.option_label[for="Right Side-design-image"]`)?.click();
}else if(locationKey.includes('Back Center')){
   document.querySelector(`.custom-block label.design_option.option_label[for="Back Center-design-image"]`)?.click();
}
validateCustomBlocks();
}

// RENDER ALL BLOCKS BASED ON CHECKED OPTIONS
function renderAllCustomBlocks() {
  const container = document.getElementById('customization-container');
  document.querySelectorAll('.custom-block').forEach(block => {
    const location = block.dataset.location;
    const embroidery = block.querySelector(`input[name="${location}-embroidery"]:checked`)?.value;
    const design = block.querySelector(`input[name="${location}-design"]:checked`)?.value;
    blockSelections[location] = {
      embroideryType: embroidery,
      designType: design
    };
  });
  const selectedOptions = document.querySelectorAll('.design-option.checked');
  const selectedKeys = Array.from(selectedOptions).map(opt => opt.dataset.location);
  container.querySelectorAll('.custom-block').forEach(block => {
    const location = block.dataset.location;
    if (!selectedKeys.includes(location)) {
      block.remove();
      delete blockSelections[location];
    }
  });
  selectedOptions.forEach(option => {
    const locationKey = option.dataset.location;
    const variantId = option.dataset.variantId;
    const title = option.dataset.variantTitle;
    const price = parseFloat(option.dataset.variantPrice || 0);
    const image = option.querySelector('img')?.src || '';
    const alreadyExists = container.querySelector(`.custom-block[data-location="${locationKey}"]`);
    if (!alreadyExists) {
      renderCustomizationBlock(locationKey, title, price, image, variantId);
    }
  });
}

// INITIAL RENDER ON PAGE LOAD
document.addEventListener('DOMContentLoaded', renderAllCustomBlocks);
// const items = document.querySelectorAll(".accordion-item");
// items.forEach(item => {
//   const header = item.querySelector(".accordion-header");
//   const toggle = item.querySelector(".accordion-toggle");
//   header.addEventListener("click", () => {
//     const isActive = item.classList.contains("active");
//     items.forEach(i => {
//       i.classList.remove("active");
//       i.querySelector(".accordion-toggle").innerHTML=`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" focusable="false" color="var(--token-d1ef1660-ffac-4433-8943-6c5d2aec568d, rgb(35, 18, 19))" style="user-select: none; width: 100%; height: 100%; display: inline-block; fill: var(--token-d1ef1660-ffac-4433-8943-6c5d2aec568d, rgb(35, 18, 19)); color: var(--token-d1ef1660-ffac-4433-8943-6c5d2aec568d, rgb(35, 18, 19)); flex-shrink: 0;"><g color="var(--token-d1ef1660-ffac-4433-8943-6c5d2aec568d, rgb(35, 18, 19))" weight="regular"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"></path></g></svg>`;
//     });
//     if (!isActive) {
//       item.classList.add("active");
//       toggle.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" focusable="false" color="var(--token-d1ef1660-ffac-4433-8943-6c5d2aec568d, rgb(35, 18, 19))" style="user-select: none; width: 100%; height: 100%; display: inline-block; fill: var(--token-d1ef1660-ffac-4433-8943-6c5d2aec568d, rgb(35, 18, 19)); color: var(--token-d1ef1660-ffac-4433-8943-6c5d2aec568d, rgb(35, 18, 19)); flex-shrink: 0;"><g color="var(--token-d1ef1660-ffac-4433-8943-6c5d2aec568d, rgb(35, 18, 19))" weight="regular"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z"></path></g></svg>`;
//     }
//   });
// });
document.addEventListener("click", e => {
  const header = e.target.closest(".accordion-header");
  if (!header) return;

  const item = header.closest(".accordion-item");
  const toggle = item.querySelector(".accordion-toggle");
  const isActive = item.classList.contains("active");


  header.closest(".accordion-wrapper")?.querySelectorAll(".accordion-item").forEach(i => {
    i.classList.remove("active");
    const icon = i.querySelector(".accordion-toggle");
      if(icon) {
        icon.innerHTML = arrowDoownIcon;
      }
  });

  if (!isActive && item && toggle) {
    item.classList.add("active");
    toggle.innerHTML = arrowUpIcon;
  }
});

const arrowDoownIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#000000" viewBox="0 0 256 256"><path d="M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z"/></svg>`;
const arrowUpIcon = `<svg style="rotate:180deg;" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#000000" viewBox="0 0 256 256"><path d="M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z"/></svg>`;


// Initial setup: auto-select first color and add checked class
document.querySelectorAll('.embroidery_thread_image').forEach((wrapper, index) => {
  const input = wrapper.querySelector('input.thread_color_radio');
  wrapper.addEventListener('click', () => {
    input.checked = !input.checked;
    wrapper.classList.toggle('checked', input.checked);
    updateSelectedColorsDisplay();
  });
});

// Function to show selected colors including the first one always
function updateSelectedColorsDisplay() {
  const allInputs = document.querySelectorAll('.embroidery_thread_image input.thread_color_radio');
  if (allInputs.length === 0) return;
  const selectedColors = [];
  allInputs.forEach(input => {
    if (input.checked) {
      selectedColors.push(input.value.trim());
    }
  });
  const displayEl = document.getElementById('selected-colors-display');
  if (displayEl) {
    displayEl.textContent = `Color(s) Selected:${selectedColors.length > 0 ? ' ' + selectedColors.join(', ') : ''}`;
  }
}
window.addEventListener('DOMContentLoaded', updateSelectedColorsDisplay);
function validateCustomBlocks(scrollIfInvalid = false) {
  const blocks = document.querySelectorAll('#customization-container .custom-block'); 
  const termsCheckbox = document.getElementById('terms_condition'); 
  const addToCartBtn = document.getElementById('add-to-cart');
  const frontOptions = document.querySelectorAll('.design-options.front_options .design-option');
  const frontOptionsContainer = document.querySelector('.design-options.front_options');
  const warningMsg = document.getElementById('front-option-warning');

  let allValid = true;
  let firstInvalidBlock = null;

  // Validate each custom block (image or text must be present)
  blocks.forEach(block => {
    const imageInput = block.querySelector('input[type="file"]');
    const textInput = block.querySelector('input[type="text"]');

    const hasImage = imageInput && imageInput.files.length > 0;
    const hasText = textInput && textInput.value.trim() !== '';

    if (!hasImage && !hasText) {
      allValid = false;
      if (!firstInvalidBlock) firstInvalidBlock = block;
      block.classList.add('invalid-block');
    } else {
      block.classList.remove('invalid-block');
    }
  });

  // Check front option
  const hasCheckedFrontOption = Array.from(frontOptions).some(opt => opt.classList.contains('checked'));

  if (!hasCheckedFrontOption) {
    allValid = false;
    if (warningMsg) warningMsg.style.display = 'block';
    if (scrollIfInvalid && frontOptionsContainer) {
      frontOptionsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  } else {
    if (warningMsg) warningMsg.style.display = 'none';
  }

  //  Terms checkbox
  if (!termsCheckbox || !termsCheckbox.checked) {
    allValid = false;
  }

  // Always control Add to Cart button's state based on ALL validations
  if (allValid) {
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('disabled');
  } else {
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');
  }

  // Scroll to first invalid custom block if needed
  if (!allValid && scrollIfInvalid && firstInvalidBlock) {
    firstInvalidBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  return allValid;
}


// Validate on input and change
document.addEventListener('input', function (e) {
  if (e.target.matches('.custom-block input[type="text"]')) {
    validateCustomBlocks();
  }
});

document.addEventListener('change', function (e) {
  if (e.target.matches('.custom-block input[type="file"], #terms_condition')) {
    validateCustomBlocks();
  }
});

// document.addEventListener('DOMContentLoaded', validateCustomBlocks);
document.getElementById('validation-add-to-cart')?.addEventListener('click', function () {
  const isValid = validateCustomBlocks();
  if (!isValid) {
    const errorMsg = document.getElementById('add-to-cart-error');
    if (errorMsg) {
      errorMsg.style.display = 'block';
      setTimeout(() => {
        errorMsg.style.display = 'none';
        validateCustomBlocks(true); 
      }, 1500);
    }
    return;
  }
  // Trigger real Add to Cart button if valid
  document.getElementById('add-to-cart')?.click();
});

// review order js
const reviewOrder = document.querySelector('section#step-5 a.button');
reviewOrder?.addEventListener('click', () => {
  updateOrderData(); 
  updateLeatherPatchSelectOptions();
});
function updateOrderData(){
const summary = document.getElementById('summary');
  summary.innerHTML = '';
  // STEP 1: show in default first selected variant info on review your order section
  const selectedInputs = document.querySelectorAll('.selected-variant-box');
  if (selectedInputs.length === 0) return;
  // First Variant (Show Full Info) 
  const first = selectedInputs[0];
  const image = first.dataset.variantImage;
  const title = first.dataset.variantTitle;
  const priceRaw = first.dataset.variantPrice;
  const productTitle = first.dataset.productTitle;
  const variantId = first.dataset.variantId;
  // const basePrice = parseFloat(priceRaw) || 0;
   // ---------code by (R) (start)-----------//
   const leatherPatchActive = document.querySelector('.leatherpatchactive');
   const leatherPatchPrice= document.querySelector('.artwork_variant_selector .itg_commonLeatherArtwork')?.getAttribute('data-variant-price');;
   
   const total_main_prodQty = getTotalSelectedQuantity();
   function getDiscount(qty) {
     if (qty >= 144) return 25;
     if (qty >= 96)  return 20;
     if (qty >= 48)  return 15;
     if (qty >= 24)  return 10;
     if (qty >= 12)  return 5;
     return 0;
    }
    function getDiscountedPrice(price, qty) {
      const discount = getDiscount(qty);
      const discountedPrice = price - (price * discount / 100);
      return discountedPrice.toFixed(2); // string with 2 decimals
    }
    
    const mainPrice = parseFloat(priceRaw) || 0;
    const basePrice = Number(getDiscountedPrice(mainPrice, total_main_prodQty));
    
    // ---------code by (R) (end)-----------//
  let customizationPrice = 0;

// Define both groups
const groups = ['.front_options .design-option.checked', '.back_and_side .design-option.checked'];
groups.forEach(selector => {
  document.querySelectorAll(selector).forEach(block => {
    let priceAttr = block.dataset.variantPrice;
    if (!priceAttr) {
      const priceElement = block.querySelector('[data-variant-price]');
      if (priceElement) {
        priceAttr = priceElement.dataset.variantPrice;
      }
    }
    const price = parseFloat(priceAttr || '0');
    if (!isNaN(price)) {
      customizationPrice += price;
    }
  });
});
const totalUnitPrice = (basePrice + customizationPrice).toFixed(2);
// Collect all variant titles (including first) 
let allVariantTitles = '';
selectedInputs.forEach((input) => {
  const variantTitle = input.dataset.variantTitle;
  const variantId = input.getAttribute("data-variant-id");
  const selectBoxQty = input.querySelector('input.variant-quantity').value;
  allVariantTitles += `<p class="varaint-titles" data-title="${variantTitle}" data-id ="${variantId}" data-quantity_title="${selectBoxQty} x ${variantTitle}"><span>${selectBoxQty} x </span> ${variantTitle}</p>`;
});
//  Collect total quantity from all selected variants
let totalVariantQty = 0;
selectedInputs.forEach((input) => {
  const qtyInputs = input.querySelectorAll('.variant-quantity');
  qtyInputs.forEach((qtyInput) => {
    const qtyValue = parseInt(qtyInput.value || '0', 10);
    if (!isNaN(qtyValue)) totalVariantQty += qtyValue;
  });
});
  //  Inject into summary 
  summary.innerHTML += `
    <div class="step-first-info" data-id="${variantId}">
      <div class="img_title_wrapper">
        <div class="step-first-selected-var-img">
          <img src="${image}" alt="${title}" />
        </div>
        <div class="step-first-selected-var-inner-info">
          <h5 class="pro_heading"><strong>${productTitle}</strong></h5>
          <h5 class="customized-label"><strong>Customized</strong></h5>
          <p class="var_label"><strong>Colors</strong></p>
          <div class="itg_variants">${allVariantTitles}</div>       
        </div>
      </div>
      <div class="price-wrapper">
        <h4 class="main_pro_price"><strong>$${totalUnitPrice}</strong> <span>Per Hat</span></h4>
        <p class="main_price_label base_price"><span class="selected_variants_total_price">$${basePrice.toFixed(2)} ${basePrice < mainPrice ? `<span class="main_price">$${mainPrice.toFixed(2)}</span>` : ''}</span> <strong class="selected_price_label">Base Price</strong></p>
        <p class="main_price_label customized_price"><span class="selected_customization_total_price">+ $${customizationPrice.toFixed(2)}</span> <strong class="selected_customization_price_pabel">Customizations</strong></p>
        <p class="main_price_label total_selected_qtys">${totalVariantQty} Hats <strong class="qtys_label">Quantity</strong></p>
      </div>
    </div>
  `;
// STEP 2: show Customizations variant info on review your order section
const customizationBlocks = document.querySelectorAll('.custom-block');
if (customizationBlocks.length) {
const customizationContainer = document.createElement('div');
customizationContainer.classList.add('customization_content');
  // Setup price listeners and calculation first
function calculateTotalCustomizedPrice() {
  const flatOptions = document.querySelectorAll('.flat_groups .design-option.checked');
  const threedOptions = document.querySelectorAll('.three_d_groups .design-option.checked');
  const front_leather_groups = document.querySelectorAll('.front_leather_groups .design-option.checked');
  const backAndSideOptions = document.querySelectorAll('.back_and_side .design-option.checked');
  const allSelectedOptions = [...flatOptions, ...threedOptions, ...front_leather_groups, ...backAndSideOptions];
  let updatedMainPrice = 0;
  allSelectedOptions.forEach(option => {
    const price = parseFloat(option.dataset.variantPrice) || 0;
    updatedMainPrice += price;
  });
  return updatedMainPrice;
}
function updateDisplayedPrice() {
  const totalPrice = calculateTotalCustomizedPrice();
  const priceElement = document.querySelector('.customization_prices');
  if (priceElement) {
    priceElement.textContent = `$${totalPrice.toFixed(2)}`;
  }
}
function setupPriceListeners() {
  const designOptions = document.querySelectorAll('.design-option');
  designOptions.forEach(option => {
    option.addEventListener('change', updateDisplayedPrice);
  });
}
  // Append blocks and build summary
customizationBlocks.forEach(block => {
    const title = block.querySelector('h4')?.textContent || '';
    const image = block.querySelector('img')?.src || '';
    const price = block.querySelector('.custom-price')?.textContent || '';
    const text = block.querySelector('input[type="text"]')?.value || '';
    const fileInput = block.querySelector('input[type="file"]');
    const fileName = fileInput && fileInput.files.length ? fileInput.files[0].name : '';
    const fileUrl = fileInput && fileInput.files.length ? URL.createObjectURL(fileInput.files[0]) : '';
    const customizedVariantId = block.dataset.variantId;
    // const designType = block.querySelector('.embroidery-option')?.dataset.value || '';
    const leatherPatchActive = block.closest('.leatherpatchactive');
    const designType = Array.from(block.querySelectorAll('.embroidery-option'))
      .filter(b => b.querySelector('input:checked'))
      .map(b => b.closest('.embroidery-option')?.dataset.value || '');

    const customBlock = document.createElement('div');
    customBlock.classList.add('review-custom-block', 'second_step_info');
    customBlock.setAttribute('data-customized-id', customizedVariantId);
    if(leatherPatchActive && title.includes('Front')){
      customBlock.innerHTML = `
        <div class="customized_data leahterPatchCustomizedDisplay">
          <div class="customization_info">
            <div class="customization_img"><img src="${image}" alt="${title}" /></div>
            <div class="data_titles prices">
            <div class="title_price">
              <h6><strong>${title}</strong></h6>
              <p class="cutomized_product_price">${price}</p>
            </div>
            <div class="customized_types">
             ${designType ? `
                <p class="design_type"><strong>Leather Patch </strong></p>
              ` : ''}
              ${fileName ? `<p><strong>Image</strong></p>` : ''}
            </div>
            <div class="desgin_type_value">
              ${designType ? `
                <p class="design_type_value">Circle, Brown (Etched in Black) </p>
              ` : ''}
              ${fileName ? `<div class="file"><a href="${fileUrl}" target="_blank">Uploaded File</a></div>` : ''}
            </div>
            </div>
          </div>
        </div>
      `;
    }else{
      customBlock.innerHTML = `
        <div class="customized_data">
          <div class="customization_info">
            <div class="customization_img"><img src="${image}" alt="${title}" /></div>
            <div class="data_titles prices">
            <div class="title_price">
              <h6><strong>${title}</strong></h6>
              <p class="cutomized_product_price">${price}</p>
            </div>
            <div class="customized_types">
            ${designType ? `
                <p class="design_type"><strong>Embroidery Type</strong></p>
              ` : ''}
              ${text ? `<p><strong>Text</strong></p>` : ''}
              ${fileName ? `<p><strong>Image</strong></p>` : ''}
            </div>
            <div class="desgin_type_value">
              ${designType ? `
                <p class="design_type_value">${designType} Embroidery</p>
              ` : ''}
              ${text ? `<div><span class="type_text">${text}</span></div>` : ''}
              ${fileName ? `<div class="file"><a href="${fileUrl}" target="_blank">Uploaded File</a></div>` : ''}
            </div>
            </div>
          </div>
        </div>
      `;
    }
    customizationContainer.appendChild(customBlock);
});

  // Add the customization header only once
  summary.innerHTML += `
    <div class="customization_header_block">
      <h5>Customizations</h5>
      <h5 class="customization_prices">$0.00</h5>
    </div>
  `;
  summary.appendChild(customizationContainer);
  setupPriceListeners();
  updateDisplayedPrice();
}
  syncUIQuantities();
  const { totalQty } = getTotalVariantQuantityAndPrice();
  calculateCustomizationBlocksPrice(totalQty);
  extraArtWorkSetUpProduct();
}
// change customized input value on input change
const customizationBlocksInput = document.querySelectorAll('.custom-block');
const reviewCustomizationInputVal = document.querySelector('.type_text');
if (customizationBlocksInput.length && reviewCustomizationInputVal) {
  customizationBlocksInput.forEach(block => {
    const textInputs = block.querySelectorAll('input[type="text"]');
    textInputs.forEach(input => {
      input.addEventListener('input', function () {
        const inputValue = input.value;
        reviewCustomizationInputVal.innerHTML = inputValue;
      });
    });
  });
}
//  STEP 1: Get total variant quantity and base price
function getTotalVariantQuantityAndPrice() {
  let totalQty = 0;
  let totalPrice = 0;
  document.querySelectorAll('.selected-variant-box').forEach(box => {
    const qty = parseInt(box.querySelector('.variant-quantity')?.value || '1', 10);
    const pricePerUnit = parseFloat(box.dataset.variantPrice) || 0;
    totalQty += qty;
    totalPrice += pricePerUnit * qty;
  });
  return { totalQty, totalPrice };
}
//  STEP 2: Get selected addon price (only if it has `active` class)
function getSelectedAddonPrice(totalQty) {
  const selectElement = document.querySelector('select.artwork_variant_selector');
  if (!selectElement) return 0;
  const selectedOption = Array.from(selectElement.options).find(opt =>
    opt.classList.contains('active')
  );
  if (!selectedOption) return 0;
  const pricePerUnit = parseFloat(selectedOption.dataset.variantPrice) || 0;
  // return pricePerUnit * totalQty;
  return pricePerUnit * 1;
}
//  STEP 3: Calculate Extra Artwork setup product prices
function extraArtWorkSetUpProduct() {
  const qty = parseInt(document.querySelector('.selected_item_qty')?.innerText || '0', 10);
  if (!qty || isNaN(qty)) return;
  const artworkSelect = document.querySelector('.artwork_variant_selector');
  if (!artworkSelect) return;
  const activeOption = Array.from(artworkSelect.options).find(opt =>
    opt.classList.contains('active')
  );
  const artworkType = activeOption?.value.trim().toLowerCase();
  // STEP 1: Check setup fee
  let artworkSetupFee = 0;
  if (artworkType && artworkType.includes('standard') && qty < 12) {
    artworkSetupFee = 25;
  } else if (artworkType && artworkType.includes('premium') && qty < 36) {
    artworkSetupFee = 25;
  }
  // STEP 2: Calculate everything with the setup fee
  const { totalQty } = getTotalVariantQuantityAndPrice();
  calculateCustomizationBlocksPrice(totalQty, artworkSetupFee);
}

//  STEP 4: Calculate only base + addon prices
function calculateBaseAndAddonPrice() {
  const { totalQty, totalPrice: basePrice } = getTotalVariantQuantityAndPrice();
  const addonPrice = getSelectedAddonPrice(totalQty);
  // const total = basePrice + addonPrice;
  const total = basePrice ;
  const AddonsFinalTotal = addonPrice;
  // updatePriceDisplay(total, 'Base + Addon', AddonsFinalTotal);
  return total;
}

//  STEP 5: Calculate customization block price based on `.checked` class
function calculateCustomizationBlocksPrice(totalQty, setupFee = 0) {
  let customizationTotal = 0;
  const blocks = [
    '.design-options.flat_groups .design-option.checked',
    '.design-options.three_d_groups .design-option.checked',
    '.design-options.front_leather_groups .design-option.checked',
    '.design-options.back_and_side .design-option.checked'
  ];
  blocks.forEach(selector => {
    document.querySelectorAll(selector).forEach(block => {
      const price = parseFloat(block.dataset.variantPrice) || 0;
      customizationTotal += price * totalQty;
    });
  });
  const { totalPrice: basePrice } = getTotalVariantQuantityAndPrice();
  const addonPrice = getSelectedAddonPrice(totalQty);
  // const addonPrice = calculateBaseAndAddonPrice();
   // const finalTotal = basePrice + addonPrice + customizationTotal + setupFee;
  const finalTotal = basePrice;
  // const AddonsFinalTotal = addonPrice + customizationTotal + setupFee;
  const AddonsFinalTotal = addonPrice + customizationTotal + setupFee;
  // updatePriceDisplay(finalTotal, 'Total with Setup');
  updatePriceDisplay(finalTotal, 'Total with Setup' , AddonsFinalTotal);
  
//----------code by (R) (start)---------//
  //----------this code for leather patch selected than add common leather patch variant with main products quantity (start)---------//
      // const selectedLeatherPatch = document.querySelector('.leatherpatchactive');
      // const commonLeatherPatchVariant = document.querySelector('.artwork_variant_selector .itg_commonLeatherArtwork');
      // if(selectedLeatherPatch && commonLeatherPatchVariant){
      //   const commonLeatherPatchVariantPrice = commonLeatherPatchVariant?.getAttribute('data-variant-price');
      //   // const finalTotalWithCommonLeatherPrice  = finalTotal + (commonLeatherPatchVariantPrice * totalQty);
      //   const CommonLeatherPrice  = commonLeatherPatchVariantPrice * totalQty;
      //   const AddonsFinalTotal = addonPrice + customizationTotal + setupFee + CommonLeatherPrice;
      //   updatePriceDisplay(finalTotal, 'Total with Setup',  AddonsFinalTotal);
      // }else{
      //   updatePriceDisplay(finalTotal, 'Total with Setup' , AddonsFinalTotal);
      // }
  //----------this code for leather patch selected than add common leather patch variant with main products quantity (End)---------//
//----------code by (R) (End)---------//

}

//  STEP 6: Update price in UI
function updatePriceDisplay(amount, label = '' , AddonsFinalTotal) {
  const offerMessage  = document.querySelector('.itg_offer_message');
  const discountPercent = document.querySelectorAll('.discountPercent');
  const beforeDiscountMsg = document.querySelectorAll('.free_setup_text');
  const total_main_price = amount.toFixed(2);

  const total_main_prodQty = getTotalSelectedQuantity();
  let discount = 0;
  if(total_main_prodQty >= 12 && total_main_prodQty <= 23){
    discount = 5 ;// in percent(5%)
    offerMessage.innerHTML = `<strong>Order more and save!</strong><p>Buy <span class="dis_num">24</span> or more to get <span class="dis_num">10% OFF</span></p>`;
    beforeDiscountMsg.forEach(el => {
      el.style.display = 'none';
    });
    discountPercent.forEach(el => {
      el.innerText = `(${discount}% OFF)`;
    });
  }
  else if(total_main_prodQty >= 24 && total_main_prodQty <= 47){
    discount = 10 ;// in percent(10%)
    offerMessage.innerHTML = `<strong>Order more and save!</strong><p>Buy <span class="dis_num">48</span> or more to get <span class="dis_num">15% OFF</span></p>`;
    beforeDiscountMsg.forEach(el => {
      el.style.display = 'none';
    });
    discountPercent.forEach(el => {
      el.innerText = `(${discount}% OFF)`;
    });
  }
  else if(total_main_prodQty >= 48 && total_main_prodQty <= 95){
    discount = 15 ;// in percent(15%)
    offerMessage.innerHTML = `<strong>Order more and save!</strong><p>Buy <span class="dis_num">96</span> or more to get <span class="dis_num">20% OFF</span></p>`;
    beforeDiscountMsg.forEach(el => {
      el.style.display = 'none';
    });
    discountPercent.forEach(el => {
      el.innerText = `(${discount}% OFF)`;
    });
  }
  else if(total_main_prodQty >= 96 && total_main_prodQty <= 143){
    discount = 20 ;// in percent(20%)
    offerMessage.innerHTML = `<strong>Order more and save!</strong><p>Buy <span class="dis_num">145</span> or more to get <span class="dis_num">25% OFF</span></p>`;
    beforeDiscountMsg.forEach(el => {
      el.style.display = 'none';
    });
    discountPercent.forEach(el => {
      el.innerText = `(${discount}% OFF)`;
    });
  }
  else if(total_main_prodQty >= 144 ){
    discount = 25 ;// in percent(25%)
      offerMessage.innerHTML = `<p><strong>🔓 </strong> <em>You've got <span class="dis_num"> 25% OFF </span></em></p>`;
    beforeDiscountMsg.forEach(el => {
      el.style.display = 'none';
    });
      discountPercent.forEach(el => {
        el.innerText = `(${discount}% OFF)`;
      });
  }else{
    beforeDiscountMsg.forEach(el => {
      el.style.display = 'inline-block';
    });
    discountPercent.forEach(el => {
        el.innerText = ``;
    });
  }
  // const discountPrice =  (total_main_price * discount) / 100;
  // const discountTotalPrice = (total_main_price - discountPrice).toFixed(2);
  // const priceEls = document.querySelectorAll('.customization-total-price');
  // priceEls.forEach((el) => {
  //   if(discount > 0){
  //     el.innerHTML = ` <span class="price_wrapper"><span class="main_price">$${total_main_price}</span><span class="main_discount_price">$${discountTotalPrice}</span></span><span class="discount_icon_text"style="color:#c01d26;"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#c01d26" viewBox="0 0 256 256" style="rotate:90deg"><path d="M243.31,136,144,36.69A15.86,15.86,0,0,0,132.69,32H40a8,8,0,0,0-8,8v92.69A15.86,15.86,0,0,0,36.69,144L136,243.31a16,16,0,0,0,22.63,0l84.68-84.68a16,16,0,0,0,0-22.63Zm-96,96L48,132.69V48h84.69L232,147.31ZM96,84A12,12,0,1,1,84,72,12,12,0,0,1,96,84Z"></path></svg>${discount}% OFF</span>`;
  //   }else {
  //     el.innerHTML = ` $${total_main_price}`;
  //     offerMessage.innerHTML = `<strong>Order more and save!</strong><p>Buy <span class="dis_num">12</span> or more to get <span class="dis_num">5% OFF</span></p>`
  //   };
  // });
    const totalMainPriceNum = Number(total_main_price) || 0;
    const addonsTotalNum = Number(AddonsFinalTotal) || 0;
    const discountNum = Number(discount) || 0;
    // Calculate discount
    const discountPrice = (totalMainPriceNum * discountNum) / 100;
    // Total with addons
    const TotalPriceWithAddon = (totalMainPriceNum + addonsTotalNum).toFixed(2);
    // Total after discount + addons
    const discountTotalPrice = ((totalMainPriceNum - discountPrice) + addonsTotalNum).toFixed(2);
    // Update elements
    const priceEls = document.querySelectorAll('.customization-total-price');

    priceEls.forEach((el) => {
    if (discountNum > 0) {
      el.innerHTML = `
        <span class="price_wrapper">
          <span class="main_price">$${TotalPriceWithAddon}</span>
          <span class="main_discount_price">$${discountTotalPrice}</span>
        </span>
        <span class="discount_icon_text" style="color:#c01d26;">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#c01d26" viewBox="0 0 256 256" style="rotate:90deg">
            <path d="M243.31,136,144,36.69A15.86,15.86,0,0,0,132.69,32H40a8,8,0,0,0-8,8v92.69A15.86,15.86,0,0,0,36.69,144L136,243.31a16,16,0,0,0,22.63,0l84.68-84.68a16,16,0,0,0,0-22.63Zm-96,96L48,132.69V48h84.69L232,147.31ZM96,84A12,12,0,1,1,84,72,12,12,0,0,1,96,84Z"></path>
          </svg>
          ${discountNum}% OFF
        </span>
      `;
    } else {
      el.innerHTML = ` $${TotalPriceWithAddon}`;

      const offerMessage = document.querySelector('.offer-message'); 
      if (offerMessage) {
        offerMessage.innerHTML = `
          <strong>Order more and save!</strong>
          <p>Buy <span class="dis_num">12</span> or more to get <span class="dis_num">5% OFF</span></p>
        `;
      }
    }
    });
}

//  STEP 7: Sync UI quantities with totalQty
function syncUIQuantities() {
  const { totalQty } = getTotalVariantQuantityAndPrice();
  document.querySelectorAll('.addon-product-quantity').forEach(input => {
    input.value = totalQty;
  });
  [
    '.design-options.flat_groups .design-option.checked .custom-quantity',
    '.design-options.three_d_groups .design-option.checked .custom-quantity',
    '.design-options.back_and_side .design-option.checked .custom-quantity'
  ].forEach(selector => {
    document.querySelectorAll(selector).forEach(input => {
      const qty = parseInt(input.value, 10);
      if (!qty || qty < 1) {
        input.value = totalQty;
      }
    });
  });
}

//  STEP 8: Quantity increment/decrement button support
document.querySelectorAll('.selected-variant-box').forEach(box => {
  const input = box.querySelector('.variant-quantity');
  const plusBtn = box.querySelector('.qty-plus');
  const minusBtn = box.querySelector('.qty-minus');
  plusBtn?.addEventListener('click', () => {
    input.value = parseInt(input.value || '0', 10) + 1;
    input.dispatchEvent(new Event('change'));
  });
  minusBtn?.addEventListener('click', () => {
    const current = parseInt(input.value || '0', 10);
    if (current > 1) {
      input.value = current - 1;
      input.dispatchEvent(new Event('change'));
    }
  });
});

//  STEP 9: On page load
document.addEventListener('DOMContentLoaded', () => {
  syncUIQuantities();
  const { totalQty } = getTotalVariantQuantityAndPrice();
  calculateCustomizationBlocksPrice(totalQty);
    extraArtWorkSetUpProduct();
    setTimeout(() => {
      syncUIQuantities();
      const { totalQty } = getTotalVariantQuantityAndPrice();
      calculateCustomizationBlocksPrice(totalQty);
      extraArtWorkSetUpProduct();
    }, 3000);
});

document.body.addEventListener('input', e => {
  if (e.target.matches('radio , checkbox , input, select, textarea')) {
    setTimeout(() => {
      syncUIQuantities();
      const { totalQty } = getTotalVariantQuantityAndPrice();
      calculateCustomizationBlocksPrice(totalQty);
      extraArtWorkSetUpProduct();
      checkSelectedArtworkOption();
    }, 500);
      checkSelectedArtworkOption();
  }
});

document.body.addEventListener('change', e => {
  if (e.target.matches('input[type="checkbox"], input[type="radio"], select')) {
    setTimeout(() => {
      syncUIQuantities();
      const { totalQty } = getTotalVariantQuantityAndPrice();
      calculateCustomizationBlocksPrice(totalQty);
      extraArtWorkSetUpProduct();
    }, 500);
  }
});

document.addEventListener('click', function (e) {
  if (e.target.matches('.quantity-selector button')) {
    setTimeout(() => {
      syncUIQuantities();
      const { totalQty } = getTotalVariantQuantityAndPrice();
      calculateCustomizationBlocksPrice(totalQty);
      extraArtWorkSetUpProduct();
    }, 10);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  syncUIQuantities();
  const { totalQty } = getTotalVariantQuantityAndPrice();
  extraArtWorkSetUpProduct(); 
  setTimeout(() => {
    extraArtWorkSetUpProduct();
  }, 2000); 
  extraArtWorkSetUpProduct();
});

// function waitForElement(selector, callback, maxAttempts = 50, interval = 100) {
//   let attempts = 0;
//   const timer = setInterval(() => {
//     const element = document.querySelector(selector);
//     if (element) {
//       clearInterval(timer);
//       callback(element);
//     } else if (++attempts >= maxAttempts) {
//       clearInterval(timer);
//       console.warn(`Element ${selector} not found after ${maxAttempts} attempts`);
//     }
//   }, interval);
// }

document.addEventListener('DOMContentLoaded', () => {
document.getElementById('add-to-cart').addEventListener('click', function (e) {
  e.preventDefault();
  document.getElementById('full-page-loader').style.display = 'flex';
  const mainInputWrapper = document.querySelector('.main_product_inputs');
  if (mainInputWrapper) mainInputWrapper.innerHTML = '';
  const hiddenInputWrapper = document.querySelector('.hidden_customized_input');
  if (hiddenInputWrapper) hiddenInputWrapper.innerHTML = '';
  let globalIndex = 0;
  function generateRandomWord(length = 15) {
    const letters = 'abcdefghijklmnopqrstuvwxyz';
    let word = '';
    for (let i = 0; i < length; i++) {
      word += letters[Math.floor(Math.random() * letters.length)];
    }
    return word;
  }
  const getRandom = generateRandomWord();
  let finalQty = 0;
  const selectedMainVariants = document.querySelectorAll('.selected-variant-box');
  selectedMainVariants.forEach((block) => {
    const mainProductVariantId = block.dataset.variantId;
    const qtyInput = block.querySelector('.variant-quantity');
    const qty = parseInt(qtyInput?.value || '1');
    const inputs = [
      { name: `items[${globalIndex}][id]`, value: mainProductVariantId },
      { name: `items[${globalIndex}][quantity]`, value: qty },
      { name: `items[${globalIndex}][properties][_Selected Variant]`, value: true }
    ];
      let allVariants = document.querySelectorAll(".itg_variants .varaint-titles");
      if(allVariants){
          let finalVariants = Array.from(allVariants)
          // .map(item => item.dataset.title?.trim())
          .map(item => item.dataset.quantity_title?.trim())
          .filter(Boolean);
          finalVariants.forEach((item, i) => {
            inputs.push({
                name: `items[${globalIndex}][properties][_Variant Title - ${i + 1}]`,
                value: item
              });
            });
      }
    const colorInputs = document.querySelectorAll('.embroidery_thread_image.checked input[type="checkbox"]');
    const selectedColors = Array.from(colorInputs).map(input => input.value.trim()).filter(Boolean);
    const combinedColorString = selectedColors.join(', ');
    if (combinedColorString) {
      inputs.push({ name: `items[${globalIndex}][properties][_Thread Color]`, value: combinedColorString });
    }
    let patchShape = document.querySelector('#patch_shape');
    if (patchShape?.value) {
      inputs.push({ name: `items[${globalIndex}][properties][Patch Shape]`, value: patchShape.value });
    }
    let patchColor = document.querySelector('#patch_color');
    if (patchColor?.value) {
      inputs.push({ name: `items[${globalIndex}][properties][_Patch Color]`, value: patchColor.value });
    }
    const customBlocks = document.querySelectorAll('.custom-block');
    customBlocks.forEach((block) => {
    const header_title = block.querySelector('.header_title')?.innerText ;
    const textInputs = block.querySelectorAll('input[type="text"]');
    textInputs.forEach((input, idx) => {
      const text = input.value.trim();
      if (text) {
        const label = textInputs.length > 1 ? `${header_title} Text ${idx + 1}` : `${header_title} Text`;
        inputs.push({
          name: `items[${globalIndex}][properties][${label}]`,
          value: text
        });
      }
    });
      const fileInput = block.querySelector('.files');
      if (fileInput && fileInput.files.length > 0) {
        const cloneFileInput = fileInput.cloneNode();
        cloneFileInput.files = fileInput.files;
        cloneFileInput.name = `items[${globalIndex}][properties][${header_title} Design]`;
        mainInputWrapper.appendChild(cloneFileInput);
      }
    });
     let threadNote = document.querySelector("#thread_notes");
    if (threadNote?.value.trim()) {
      inputs.push({ name: `items[${globalIndex}][properties][_Thread Note]`, value: threadNote.value.trim() });
    }
    let leatherNote = document.querySelector("#leather_patch_notes");
    if (leatherNote?.value.trim()) {
      inputs.push({ name: `items[${globalIndex}][properties][_Leather Note]`, value: leatherNote.value.trim() });
    }
    let orderNote = document.querySelector("#order_notes");
    if (orderNote?.value.trim()) {
      inputs.push({ name: `items[${globalIndex}][properties][_Order Note]`, value: orderNote.value.trim() });
    }
    if(getRandom){
      inputs.push({
        name: `items[${globalIndex}][properties][_Bundle Id]`,
        value: getRandom
      })
    }
    if (globalIndex === 0) {
       const totalItem = getTotalSelectedQuantity();
      inputs.push(
        { name: `items[${globalIndex}][properties][_Main product]`, value: 'Yes' },
        { name: `items[${globalIndex}][properties][_Total items]`, value: totalItem },
        { name: `items[${globalIndex}][properties][_Selected Variant]`, value: 'Yes' }
      );
    }
    const termsCheckbox = document.querySelector('#terms_condition');
    if (termsCheckbox?.checked) {
      inputs.push({ name: `items[${globalIndex}][properties][_Terms & Condition]`, value: 'Agreed' });
    }
    inputs.forEach(data => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = data.name;
      input.dataset.index = globalIndex;
      input.value = data.value;
      mainInputWrapper.appendChild(input);
    });
    finalQty += qty;
    globalIndex++;
  });

// ADD SELECTED ADDON INPUTS ===
let skipArtwork = false; //  prevent duplicate Free Premium Artwork
const addonSelect = document.querySelector('.extra_addon_variant');
if (addonSelect) {
  const checkedTitles = Array.from(document.querySelectorAll('.artwork_block.checked'))
    .map(block => block.getAttribute('data-title')?.trim())
    .filter(Boolean);
  let selectedArtworkValue = '';
  const varSelect = document.querySelector('.artwork_variant_selector');
  if (varSelect && checkedTitles.length) {
    const matchedOption = Array.from(varSelect.options).find(option => {
      const value = option.value.toLowerCase();
      return checkedTitles.every(title => value.includes(title.toLowerCase()));
    });
    if (matchedOption) {
      selectedArtworkValue = matchedOption.value.toLowerCase();
    }
  }
  const totalselectedItem = getTotalSelectedQuantity();
  let selectedAddonId = null;
  if (totalselectedItem >= 36) {
    selectedAddonId = '50212272210198';
  } else {
    let selectedIndex = -1;
    if (totalselectedItem < 12 && selectedArtworkValue.includes('standard')) {
      selectedIndex = 0;
    } else if (totalselectedItem >= 12 && selectedArtworkValue.includes('standard')) {
      selectedIndex = 4;
    } else if (totalselectedItem < 36 && selectedArtworkValue.includes('premium')) {
      selectedIndex = 1;
    } else if (totalselectedItem >= 36 && selectedArtworkValue.includes('premium')) {
      selectedIndex = 2;
    }
    if (selectedIndex >= 0) {
      const addonOptions = addonSelect.querySelectorAll('option');
      addonOptions.forEach((option, index) => {
        option.selected = index === selectedIndex;
        option.classList.toggle('active', index === selectedIndex);
      });
      const selectedOption = addonOptions[selectedIndex];
      if (selectedOption) {
        selectedAddonId = selectedOption.value;
      } else {
        console.warn('Selected addon option is undefined');
      }
    }
  }

  if (selectedAddonId) {
    const addonInputs = [
      { name: `items[${globalIndex}][id]`, value: selectedAddonId },
      { name: `items[${globalIndex}][quantity]`, value: 1 },
      { name: `items[${globalIndex}][properties][_Bundle Id]`, value: getRandom },
      { name: `items[${globalIndex}][properties][_Artwork]`, value: true }
    ];
    addonInputs.forEach(data => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = data.name;
      input.dataset.index = globalIndex;
      input.value = typeof data.value === 'function' ? data.value() : data.value;
      mainInputWrapper.appendChild(input);
    });
    globalIndex++;
  }
}

// === Artwork Variant Inputs ===

  //   // CommonLeatherPatchVariant Artwork Variant //
  //     const selectedLeatherPatch = document.querySelector('.leatherpatchactive');
  //     const CommonLeatherPatchOption = document.querySelector('.itg_commonLeatherArtwork');
  //     if (selectedLeatherPatch && CommonLeatherPatchOption) {
  //       [
  //         { name: `items[${globalIndex}][id]`, value: CommonLeatherPatchOption.dataset.variantId },
  //         { name: `items[${globalIndex}][quantity]`, value: getTotalSelectedQuantity() || 1 },
  //         { name: `items[${globalIndex}][properties][_Bundle Id]`, value: getRandom },
  //         { name: `items[${globalIndex}][properties][_select artwork]`, value: true },
  //         { name: `items[${globalIndex}][properties][common leather artwork]`, value: true }
  //       ].forEach(data => {
  //       const input = document.createElement('input');
  //       input.type = 'hidden';
  //       input.name = data.name;
  //       input.dataset.index = globalIndex;
  //       input.value = data.value;
  //       hiddenInputWrapper.appendChild(input);
  //     });
  //       globalIndex++;
  //     }

  // // CommonLeatherPatchVariant Artwork Variant //

  
const activeOption = document.querySelector('.artwork_variant_selector option.active');

if (activeOption) { 
  let artworkSelectedVariantId = activeOption.dataset.variantId;
  let artworkSelectedTitle = activeOption.value;
  const totalItem = getTotalSelectedQuantity();
  const artworkSelectedVariantTitle = activeOption.value;
  hiddenInputWrapper.querySelectorAll(`[data-index="${globalIndex}"]`).forEach(el => el.remove());
  const selectedMainVariantsQty = document.querySelectorAll('.selected-variant-box');
  let totalQty = 0;
  selectedMainVariantsQty.forEach((block) => {
    const qtyInputs = block.querySelector('.variant-quantity');
    totalQty += parseInt(qtyInputs?.value || '1');
  });
  const inputs = [
    { name: `items[${globalIndex}][id]`, value: artworkSelectedVariantId },
    { name: `items[${globalIndex}][quantity]`, value: 1 },
    { name: `items[${globalIndex}][properties][_Bundle Id]`, value: getRandom },
    { name: `items[${globalIndex}][properties][_select artwork]`, value: true }
  ];
  if (artworkSelectedVariantTitle.includes('Embroidery')) {
    const colorInputs = document.querySelectorAll('.embroidery_thread_image.checked input[type="checkbox"]');
    const selectedColors = Array.from(colorInputs).map(input => input.value.trim()).filter(Boolean);
    const combinedColorString = selectedColors.join(', ');
    if (combinedColorString) {
      inputs.push({ name: `items[${globalIndex}][properties][Thread Color]`, value: combinedColorString });
    }
    let threadNote = document.querySelector("#thread_notes");
    if (threadNote?.value.trim()) {
      inputs.push({ name: `items[${globalIndex}][properties][Thread Note]`, value: threadNote.value.trim() });
    }
  }
  if (artworkSelectedVariantTitle.includes('Leather')) {
    let leatherNote = document.querySelector("#leather_patch_notes");
    if (leatherNote?.value.trim()) {
      inputs.push({ name: `items[${globalIndex}][properties][Leather Note]`, value: leatherNote.value.trim() });
    }
    let patchShape = document.querySelector('#patch_shape');
    if (patchShape?.value) {
      inputs.push({ name: `items[${globalIndex}][properties][Patch Shape]`, value: patchShape.value });
    }
    let patchColor = document.querySelector('#patch_color');
    if (patchColor?.value) {
      inputs.push({ name: `items[${globalIndex}][properties][Patch Color]`, value: patchColor.value });
    }
  }
  inputs.forEach(data => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = data.name;
    input.dataset.index = globalIndex;
    input.value = data.value;
    hiddenInputWrapper.appendChild(input);
  });
  globalIndex++;
}

  // Customized Product Inputs
  const customBlocks = document.querySelectorAll('.custom-block');
  customBlocks.forEach((block) => {
    const variantId = block.dataset.variantId;
    if (!variantId) return;
    const header_title = block.querySelector('.header_title')?.innerText ;
    const text = block.querySelector('input[type="text"]')?.value.trim() || '';
    const fileInput = block.querySelector('.files');
    const selectedMainVariantsQty = document.querySelectorAll('.selected-variant-box');
    let totalQty = 0;
    selectedMainVariantsQty.forEach((block) => {
      const qtyInputs = block.querySelector('.variant-quantity');
      totalQty += parseInt(qtyInputs?.value || '1');
    });
    const inputs = [
      { name: `items[${globalIndex}][id]`, value: variantId },
      { name: `items[${globalIndex}][quantity]`, value: totalQty },
      { name: `items[${globalIndex}][properties][_Bundle Id]`, value: getRandom },
      { name: `items[${globalIndex}][properties][_addon]`, value: true }
    ];
    if (text) {
      inputs.push({ name: `items[${globalIndex}][properties][Text]`, value: text });
    }
    inputs.forEach(inputData => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputData.name;
      input.dataset.index = globalIndex;
      input.value = inputData.value;
      hiddenInputWrapper.appendChild(input);
    });


  // ✅ File input handling
  if (fileInput && fileInput.files.length > 0) {
      const cloneFileInput = fileInput.cloneNode();
      cloneFileInput.files = fileInput.files;
      cloneFileInput.name = `items[${globalIndex}][properties][Design]`;
      mainInputWrapper.appendChild(cloneFileInput);
  }

    
    globalIndex++;
  });
  const allInputs = [...mainInputWrapper.querySelectorAll('input'), ...hiddenInputWrapper.querySelectorAll('input')];
  const formData = new FormData();
  allInputs.forEach(input => {
    if (input.type === 'file' && input.files.length > 0) {
      formData.append(input.name, input.files[0]);
    } else {
      formData.append(input.name, input.value);
    }
  });
  fetch('/cart/add.js', {
  method: 'POST',
  body: formData
})
  .then(res => res.json())
  .then(data => {
    window.updateHeaderCartHtml = function(ignoreCartAction) {
      if ((theme.cartAction == 'redirect' || theme.cartAction == 'redirect_checkout') && ignoreCartAction == false) {
        return;
      }
      var cartSelector = BT.selectors.cart, ins = this;
      new Promise(function(resolve, reject) {
        BT.callAjax(theme.rootUrl, 'GET', { view: 'header_cart' }, null, function(response) {
          var htmlHeaderCart = $(cartSelector.header, response).html();
          var headerCartSelector = cartSelector.header;
          $(headerCartSelector).each(function() {
            $(this).html(BT.processSameId(htmlHeaderCart));
          });
          var number = $(cartSelector.number, response).html();
          var total = $(cartSelector.total, response).html();
          // $(cartSelector.number).html(number);
           const itg_cartButton = document.querySelector('#bt-sidebar-cart .itg_mainCount').innerHTML; 
            if(itg_cartButton){
              $(cartSelector.number).html(itg_cartButton);
            }else{
              $(cartSelector.number).html(number);
            }
          $(cartSelector.total).html(total);
          BT.updateFaviconBadge(number);
          resolve(cartSelector.header);  
        });
      }).then(function(wrapper) {
        if (wrapper != undefined) {
          BT.convertCurrencySilence(wrapper + ' span.money');
          $(document).trigger('ajaxCart.afterUpdateHeaderCartHtml');
        }
        BT.convertCurrencySilence(cartSelector.total + ' span.money');
        BT.resetCartTerms();
        $(document).trigger('ajaxCart.afterCartLoad');
        // Not run below code on cart page
        if (window.Shopify && Shopify.StorefrontExpressButtons != undefined && !$('body').hasClass('template-cart')) {
          Shopify.StorefrontExpressButtons.initialize();
        }
        setTimeout(function() {
          document.getElementById('full-page-loader').style.display = 'none';
          // $('.cart-sidebar-trigger').trigger('click'); 
        }, 300);
        //  window.location.href = '/cart';
       const drawerButton = document.querySelector('.bt-sidebar-btn[data-target="#bt-sidebar-cart"]');
        if (drawerButton) {
          drawerButton.click();
        }
      }).catch(function(err) {
        document.getElementById('full-page-loader').style.display = 'none';
        console.error('Error loading header cart:', err);
      });
    };
    window.updateHeaderCartHtml();
  })
  .catch(err => {
    console.error('Error adding to cart:', err);
  });
});
});

document.addEventListener("DOMContentLoaded", function () {


  const stepSections = document.querySelectorAll("section[id^='step-']");
  const sidebarSteps = document.querySelectorAll(".step-item");

  function setActiveSidebarStep() {
    let currentStep = "";
    const offset = 50; 

    stepSections.forEach((section) => {
      const rect = section.getBoundingClientRect();

      if (rect.top < window.innerHeight - offset && rect.bottom > offset) {
        currentStep = section.id;
      }
    });

    if (!currentStep && stepSections.length > 0) {
      currentStep = stepSections[0].id;
    }

    sidebarSteps.forEach((item) => {
      const isThisStep = item.dataset.step === currentStep;
      item.classList.toggle("active", isThisStep);

      if (item.dataset.step === "step-6" && isThisStep) {
        updateOrderData();
        updateLeatherPatchSelectOptions();
      }
    });
  }

  let scrollTimeout;
  window.addEventListener("scroll", () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(setActiveSidebarStep, 100);
  });

  setActiveSidebarStep();


  // const stepSections = document.querySelectorAll("section[id^='step-']");
  // const sidebarSteps = document.querySelectorAll(".step-item");
  // function setActiveSidebarStep() {
  //   let currentStep = "";
  //   stepSections.forEach((section) => {
  //     const rect = section.getBoundingClientRect();
  //     if (rect.top <= 150 && rect.bottom >= 150) {
  //       currentStep = section.id;
  //     }
  //   });
  //   if (!currentStep && stepSections.length > 0) {
  //     currentStep = stepSections[0].id;
  //   }
  //   sidebarSteps.forEach((item) => {
  //     const isThisStep = item.dataset.step === currentStep;
  //     item.classList.toggle("active", isThisStep);
  //     if (item.dataset.step === "step-6" && isThisStep) {
  //       updateOrderData();
  //       updateLeatherPatchSelectOptions();
  //     }
  //   });
  // }
  // let scrollTimeout;
  // window.addEventListener("scroll", () => {
  //   clearTimeout(scrollTimeout);
  //   scrollTimeout = setTimeout(setActiveSidebarStep, 100);
  // });
  // setActiveSidebarStep();

const progressBar = document.querySelector(".customization_steps_sidebar");
const step1 = document.querySelector("#step-1");
const footer = document.querySelector("footer"); 
if (!progressBar || !step1 || !footer) return;

// Initially hide
progressBar.classList.remove("visible");
function checkVisibility() {
  const stepRect = step1.getBoundingClientRect();
  const footerRect = footer.getBoundingClientRect();
  const stepPassed = stepRect.top <= 0; 
  const stepInView = stepRect.top <= window.innerHeight && stepRect.bottom >= 0;
  const footerReached = footerRect.top <= window.innerHeight;
  if ((stepInView || stepPassed) && !footerReached) {
    progressBar.classList.add("visible");
  } else {
    progressBar.classList.remove("visible");
  }
}
window.addEventListener("scroll", checkVisibility);
window.addEventListener("resize", checkVisibility);
checkVisibility();
});

// ------------ code by (RSS) start -------------------//

function updateAtworkSetup() {
  const total_hats = getTotalSelectedQuantity(); 
  const artwork_setup_option_blocks = document.querySelector('.artwork_setup_option_blocks');
  const standardBlock = artwork_setup_option_blocks?.querySelector('.artwork_block[data-title="Standard"]');
  const standardBlockHeading  = standardBlock.querySelector('.header_inner')?.querySelector('h3');
  const standardBlockInputRadio = standardBlock?.querySelector('input.option-radio[type="radio"]');
  const selectedBlock = artwork_setup_option_blocks?.querySelector('.artwork_block.checked');
  const premiumBlock = artwork_setup_option_blocks?.querySelector('.artwork_block[data-title="Premium (+$25)"]');
  const premiumBlockHeading  = premiumBlock.querySelector('.header_inner')?.querySelector('h3');
  const variantTitle = selectedBlock?.getAttribute('data-title')?.trim();
  const inputRadio = selectedBlock?.querySelector('input.option-radio[type="radio"]');
  // const heading  = selectedBlock.querySelector('.header_inner')?.querySelector('.message');
  const heading  = selectedBlock.querySelector('.header_inner')?.querySelector('h3');
  if (!variantTitle) return;
  // if (total_hats < 12) {
  //    standardBlockHeading.innerHTML=`Standard`;
  // } 
  if (total_hats < 36 ) {
    standardBlockInputRadio.disabled = false;
    premiumBlockHeading.innerHTML=`Premium (+$25)`;
  }else{
    standardBlockInputRadio.disabled = true;
  }
  if (total_hats < 12 && variantTitle.includes("Premium")) {
     // standardBlockHeading.innerHTML=`Standard`;
  }else if (total_hats < 12 && variantTitle.includes("Standard")) {
     // heading.innerHTML=`Standard`;
  } else if (total_hats >= 12  && variantTitle.includes("Standard") && total_hats < 36) {
     // heading.innerHTML=`Standard <span class="main_message"><span class="unlock_icon">🔓</span><span class="sub_message"> You’ve unlocked Free Artwork Setup</span> </span>`;
  } else if (total_hats >= 12  && total_hats < 36 && variantTitle.includes("Premium")) {
     heading.innerHTML=`Premium (+$25)`;
     // standardBlockHeading.innerHTML=`Standard <span class="main_message"><span class="unlock_icon">🔓</span> <span class="sub_message"> You’ve unlocked Free Artwork Setup</span></span>`;
  } else if (total_hats >= 36 && variantTitle.includes("Premium")) {
     heading.innerHTML=`Premium <span class="main_message"><span class="unlock_icon">🔓</span> <span class="sub_message"> You’ve unlocked Free Premium setup</span></span></span>`;
  }else if (total_hats >= 36 && variantTitle.includes("Standard")) {
    // heading.innerHTML=`Standard`;
    inputRadio.checked = false;
    inputRadio.disabled = true;
    selectedBlock?.classList.remove('checked');
    const premiumBlock = artwork_setup_option_blocks?.querySelector('.artwork_block[data-title="Premium (+$25)"]');
    const premiumInputRadio = premiumBlock?.querySelector('input.option-radio[type="radio"]');
    premiumBlock?.classList.add('checked');
    // premiumInputRadio.checked = true;
    premiumInputRadio.click();
    updateAtworkSetup();
  }
}
updateAtworkSetup();

//----------this code for customized input field empty than show warning else remove (start)---------//
function handleInputCheck(e) {
  const block = e.target.closest('.custom_block_info');
  if (!block) return;

  const hasText = [...block.querySelectorAll('input[type="text"]')]
  .some(input => input.value.trim().length > 0);

  const hasFile = [...block.querySelectorAll('input[type="file"]')]
  .some(input => input.files.length > 0);
  
  block.querySelector('.customize_block_warning').style.display = (hasText || hasFile) ? 'none' : 'block';
}

document.addEventListener('input', handleInputCheck);
document.addEventListener('change', handleInputCheck);
//----------this code for customized input field empty than show warning else remove (End)---------//
//----------this code for leather path selected than only show file select input (start)---------//

  function checkSelectedArtworkOption(retryCount = 0) {
    const selectedLabels = document.querySelectorAll('.artwork_block.checked');
    const selectedTitles = [...selectedLabels].map(label => label?.dataset.title || '');
    
    const hasLeather = selectedTitles.some(title => title.toLowerCase().includes('leather'));
    const customizationBlocks = document.querySelectorAll('#customization-container .custom-block');
    
    let foundFront = false;
    customizationBlocks.forEach(block => {
      const isFront = block.dataset.location?.toLowerCase().includes('front');
      if (isFront && hasLeather) {
        foundFront = true;
        block.classList.add('leatherpatchactive');
      } else {
        block.classList.remove('leatherpatchactive');
      }
    });

    if (hasLeather && !foundFront && retryCount < 20) {
      setTimeout(() => {
        checkSelectedArtworkOption(retryCount + 1);
      }, 300); 
    }
  }
document.querySelectorAll('.customizer-section__body .artwork_block input[type="radio"]').forEach(radio =>{
  radio.addEventListener('change',checkSelectedArtworkOption);
});

document.querySelectorAll('input').forEach(input =>{
  input.addEventListener('change',()=>{
    setTimeout(()=>checkSelectedArtworkOption, 1000)
  });
});
checkSelectedArtworkOption();
//----------this code for leather path selected than only show file select input (end)---------//


//----------this code for selected variant title update on load (start)---------//
function updateVariantNameOnLoad() {
    const el = document.querySelector('.pg__option__label .selected_variant_title');
    const proEl = document.querySelector(' .product_selected_variant span');
    if (!el || !proEl) return;
    const clean = t => t.replace(/\s*\/\s*(OSFM|Adjustable)\s*$/gi, "").trim();
    const colorEl = document.querySelector('.pg__option.swatch--color');
    const colorTitle = document.querySelector('.pg__option.swatch--color .pg__option__value.selected')?.title;
    const newTitle = colorEl ? colorTitle : " ";
    el.textContent = clean(newTitle || "");
    proEl.textContent = clean(newTitle || "");
}

document.addEventListener('DOMContentLoaded', () => {
  updateVariantNameOnLoad(); 
});

['input','change','click'].forEach(ev=>
  document.body.addEventListener(ev,e=>{
    if(e.target.closest('input,select,textarea,.artwork_block')) {
      checkSelectedArtworkOption();
      setTimeout(checkSelectedArtworkOption,1000);
    }
  })
);

//----------this code for selected variant title update on load (end)---------//
document.addEventListener('change', e=>{
  if(e.target.matches('.variants input[type=checkbox]') &&
     !document.querySelectorAll('.variant input[type=checkbox]:checked').length) {
    // e.target.checked = true;
    setTimeout(()=>{
      e.target.click();
    },500)
    // e.target.closest('.variant')?.classList.add('checked');
  }
});


// --------------------
function setUpFrontLeatherOption(){
  const selectedLeatherPatch = document.querySelector('.leatherpatchactive');
  const front_options = document.querySelectorAll('.design-options.front_options'); 
  const front_leather_groups = document.querySelector('.design-options.front_leather_groups');
   const flat_groups = document.querySelector('.design-options.flat_groups');

  if (selectedLeatherPatch && front_leather_groups) {
     front_options.forEach((elem) => elem.style.display = "none");
      front_leather_groups.style.display = "flex";
      const leatherOptions = front_leather_groups.querySelectorAll('.design-option');
      leatherOptions[1]?.click();
  } else {
    if (front_options.length > 0) {
      front_options.forEach((elem) => elem.style.display = "none");
        front_options[0].style.display = "flex";
        const options = flat_groups.querySelectorAll('.design-option');
        options[1].click();
    }
  }
}

// function setUpFrontLeatherArtWork() {
//   const selectedLeatherPatch = document.querySelector('.leatherpatchactive');
//   const checkedOption = document.querySelector('.front_leather_groups .design-option.checked');
//   const variantOptions = document.querySelectorAll('select.artwork_variant_selector option.selected_options');

//   if (!selectedLeatherPatch || !checkedOption) return;

//   const checkedTitle = checkedOption.dataset.variantTitle?.toLowerCase().trim();
//   variantOptions.forEach(item => {
//     item.classList.toggle('active', item.value?.trim().toLowerCase().includes(checkedTitle));
//   });
// }
function updateLeatherPatchSelectOptions() {
  const container = document.querySelector('.leather-patch-customization');
  const leatherPatchCustomizedDisplay = document.querySelector('.leahterPatchCustomizedDisplay');
  if (!container || !leatherPatchCustomizedDisplay) return;
  const selects = container.querySelectorAll('select');
  const values = Array.from(selects).map(select => select.value);
    // const values = Array.from(selects).map(select => select.selectedOptions[0].textContent);
  const leatherPatchType = leatherPatchCustomizedDisplay.querySelector('.design_type_value');
  if (leatherPatchType) {
    leatherPatchType.textContent = `${values.join(', ')}`; 
  }
}
const selects = document.querySelectorAll('select');
selects.forEach(select => {
  select.addEventListener('change', updateLeatherPatchSelectOptions);
});

document.querySelectorAll('.artwork_option_blocks input[type="radio"]').forEach(radio => {
  radio.addEventListener('change', () => {
    setUpFrontLeatherOption();
    updateLeatherPatchSelectOptions();
    const { totalQty } = getTotalVariantQuantityAndPrice();
    calculateCustomizationBlocksPrice(totalQty);
    extraArtWorkSetUpProduct();
    // setTimeout(() => setUpFrontLeatherArtWork(), 500);
  });
});
// document.querySelectorAll('.front_leather_groups input').forEach(radio => {
//   radio.addEventListener('change', () => {
//     setUpFrontLeatherArtWork();
//     setTimeout(() => setUpFrontLeatherArtWork(), 600);
//   });
// });
// --------------------
// ------------ code by (RSS) end. -------------------//